export default __webpack_public_path__ + "static/media/barfly-membership.54dd7174.svg";